import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { SURFACE_ANALYSIS_LEGEND } from './surface-analysis.legend';
import { SURFACE_ANALYSIS_PRODUCT_DATA } from './surface-analysis.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class SurfaceAnalysisPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(SURFACE_ANALYSIS_PRODUCT_DATA, {
    legend: SURFACE_ANALYSIS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
